import * as React from "react";
import { useForm, FormProvider, Controller } from "react-hook-form";
import { useLocation, useHistory } from "react-router";
import queryString from "query-string";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import { observer } from "mobx-react-lite";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormHelperText from "@material-ui/core/FormHelperText";
import { useStyles } from "./ParentsSearch.styles";
import { SearchTitle } from "../../components/SearchTitle/SearchTitle";
import { SearchButton } from "../../components/Buttons/SearchButton/SearchButton";
import { ParentsFilterQuery } from "../../api/typings/Filters";
import { ParentsFilterQuerySerialized, getFiltersParamsSerialized } from "../../helpers/serializers/filters";
import { tableStore } from "../../mobx/stores/TableStore/TableStore";
import { BaseTableSearcher } from "../../components/Searchers/BaseTableSearcher/BaseTableSearcher";
import { UserRoleEnum } from "../../static/enums/UserRole";

interface ParentsSearchProps {
  loading: boolean;
}

export const ParentsSearch = observer(({ loading }: ParentsSearchProps) => {
  const { getUsers } = tableStore;
  const methods = useForm();
  const { control, handleSubmit } = methods;
  const classes = useStyles();
  const location = useLocation();
  const history = useHistory();
  const params = (queryString.parse(location.search) as unknown) as ParentsFilterQuerySerialized;

  return (
    <Grid item xs={12}>
      <Paper className={classes.root}>
        <SearchTitle />
        <FormProvider {...methods}>
          <form onSubmit={handleSubmit(onSearch)}>
            <BaseTableSearcher loading={loading} />
            <Grid container spacing={2} justify={"flex-start"}>
              <Grid item lg={4} md={4} sm={12} xs={12}>
                <Controller
                  name={"profiles-parent-is_expired_subscription_payment_allowed"}
                  control={control}
                  defaultValue={params["filter[profiles][parent][is_expired_subscription_payment_allowed]"] || ""}
                  render={({ field: { onChange, value } }) => {
                    return (
                      <FormControl variant="outlined" size={"small"} className={classes.formControl}>
                        <Select
                          labelId="demo-simple-select-helper-label"
                          id="demo-simple-select-helper"
                          value={value}
                          displayEmpty
                          onChange={onChange}
                          autoWidth
                        >
                          <MenuItem value={""}>Не выбрано</MenuItem>
                          <MenuItem value={1}>Да</MenuItem>
                          <MenuItem value={0}>Нет</MenuItem>
                        </Select>
                        <FormHelperText>Разрешена оплата с истекшим тарифом</FormHelperText>
                      </FormControl>
                    );
                  }}
                />
              </Grid>
            </Grid>
            <SearchButton loading={loading} />
          </form>
        </FormProvider>
      </Paper>
    </Grid>
  );

  function onSearch(data: ParentsFilterQuery) {
    const dataSerialized = getFiltersParamsSerialized<ParentsFilterQuery, ParentsFilterQuerySerialized>(data);
    const searchString = queryString.stringify(dataSerialized);
    history.push({
      search: searchString,
    });
    getUsers({
      ...dataSerialized,
      "filter[role]": UserRoleEnum.parent,
    });
  }
});
